"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaManagerUrl = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Image_1 = tslib_1.__importDefault(require("../Image"));
var config_1 = tslib_1.__importDefault(require("../config"));
var TRANSFORMATION_DELIMINETER = '-';
exports.getMediaManagerUrl = function (picture, width, height, script) {
    if (script === void 0) { script = 'resize'; }
    if (!picture) {
        return '';
    }
    var transformOperations = [];
    if (picture.dimensions) {
        var _a = picture.dimensions, X = _a.X, Y = _a.Y, W = _a.W, H = _a.H;
        transformOperations.push(X + "x" + Y + "x" + W + "x" + H);
    }
    transformOperations.push(width + "x" + height + "x" + script);
    var size = transformOperations.join(TRANSFORMATION_DELIMINETER);
    if (picture.media_url) {
        return picture.media_url.replace('{size}', size);
    }
    else if (picture.uri) {
        return config_1.default.MEDIAMANAGER_URL + "/images/" + size + "/" + picture.uri;
    }
    return '';
};
var MediaManagerImage = /** @class */ (function (_super) {
    tslib_1.__extends(MediaManagerImage, _super);
    function MediaManagerImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaManagerImage.prototype.render = function () {
        var _a = this.props, picture = _a.picture, script = _a.script, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth, restProps = tslib_1.__rest(_a, ["picture", "script", "naturalHeight", "naturalWidth"]);
        var src = exports.getMediaManagerUrl(picture, naturalWidth, naturalHeight, script);
        return React.createElement(Image_1.default, tslib_1.__assign({}, restProps, { src: src || '' }));
    };
    return MediaManagerImage;
}(React.Component));
exports.default = MediaManagerImage;
